import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { Toast } from "primereact/toast";
import CargosMasivosDialog from "./CargosMasivosDialog";
const Cargos = () => {
  const toast = useRef(null);
  const [alumnos, setAlumnos] = useState([]);
  const [alumno, setAlumno] = useState(null);
  const [cargos, setCargos] = useState([]);
  const [conceptos, setConceptos] = useState([]);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showMasivo, setShowMasivo] = useState(false);

  const [form, setForm] = useState({
    id_concepto: null,
    periodo: "",
    fecha_vencimiento: "",
    monto: null,
  });

  useEffect(() => {
    const loadAlumnos = async () => {
      try {
        const res = await axiosPrivate.get("CEUM/alumnos/listado");
        setAlumnos(res.data);
      } catch (e) {
        console.error(e);
      }
    };
    loadAlumnos();
  }, []);

  const axiosPrivate = useAxiosPrivate();
  useEffect(() => {
    const loadConceptos = async () => {
      try {
        const res = await axiosPrivate.get("CEUM/conceptos");
        setConceptos(res.data);
      } catch (e) {
        console.error(e);
      }
    };
    loadConceptos();
  }, []);

  const buscar = async (matricula) => {
    if (!matricula) return;
    setLoading(true);
    try {
      const res = await axiosPrivate.get(`CEUM/cargos/${matricula}`);
      setCargos(res.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const guardar = async () => {
    if (!form.id_concepto || !form.periodo || !form.monto) {
      toast.current.show({
        severity: "warn",
        summary: "Advertencia",
        detail: "Completa los campos requeridos",
        life: 3000,
      });
      return;
    }
    try {
      await axiosPrivate.post("CEUM/cargos", {
        matricula: alumno?.Matricula,
        ...form,
      });

      setVisible(false);
      limpiarForm();
      buscar(alumno.Matricula);
    } catch (e) {
      console.error(e);
      toast.current.show({
                severity: "error",
                summary: "Error",
                detail: "Error al guardar",
                life: 3000,
              });
    }
  };

  const limpiarForm = () => {
    setForm({
      id_concepto: null,
      periodo: "",
      fecha_vencimiento: "",
      monto: null,
    });
  };

  const money = (v) => `$ ${Number(v || 0).toFixed(2)}`;
  
  useEffect(() => {
    if (alumno?.Matricula) {
      console.log("Buscando cargos para matricula:", alumno.Matricula);
      buscar(alumno.Matricula);
    }
  }, [alumno]);

  return (
    <Card className="card" title="Registro de cargos">
      <Toast ref={toast} />
      <div className="flex gap-2 mb-3">
        <Dropdown
          value={alumno}
          options={alumnos}
          onChange={(e) => {
            setAlumno(e.value);
            if (!e.value) {
              console.log("Alumno deseleccionado, limpiando cargos");
              setCargos([]);
            }
          }}
          optionLabel="nombre_completo"
          placeholder="Selecciona alumno"
          filter
          showClear
        />
        <Button
          label="Nuevo Cargo"
          icon="pi pi-plus"
          onClick={() => {
            if (!alumno) {
              toast.current.show({
                severity: "warn",
                summary: "Advertencia",
                detail: "Selecciona un alumno primero",
                life: 3000,
              });
              return;
            }
            setVisible(true);
          }}
        />
        <Button
        label="Cargos Masivos"
        icon="pi pi-users"
        onClick={() => setShowMasivo(true)}
      />
      </div>
      <DataTable value={cargos} paginator rows={10} className="p-datatable-sm">
        <Column field="concepto" header="Concepto" />
        <Column field="periodo" header="Periodo" />
        <Column field="fecha_vencimiento" header="Vencimiento" />
        <Column header="Monto" body={(row) => money(row.monto)} />
        <Column header="Saldo" body={(row) => money(row.saldo)} />
        <Column field="estatus" header="Estatus" />
      </DataTable>
      <CargosMasivosDialog
  visible={showMasivo}
  setVisible={setShowMasivo}
  conceptos={conceptos}
  alumnos={alumnos}
  onGuardar={async (form) => {

    console.log(form);
    //return;
    await axiosPrivate.post("CEUM/cargos/masivo", form);
    toast.current.show({
      severity: "success",
      summary: "OK",
      detail: "Cargos aplicados",
      life: 3000
    });
  }}
/>
      <Dialog
        header="Nuevo Cargo"
        visible={visible}
        style={{ width: "30vw" }}
        onHide={() => setVisible(false)}
      >
        <div className="p-fluid">
          <div className="field">
            <label>Concepto</label>
            <Dropdown
              value={form.id_concepto}
              options={conceptos}
              optionLabel="nombre"
              optionValue="id"
              onChange={(e) => setForm({ ...form, id_concepto: e.value })}
              placeholder="Selecciona"
            />
          </div>

          <div className="field">
            <label>Periodo</label>
            <InputText
              value={form.periodo}
              onChange={(e) => setForm({ ...form, periodo: e.target.value })}
              placeholder="2026-01"
            />
          </div>

          <div className="field">
            <label>Fecha vencimiento</label>
            <InputText
              value={form.fecha_vencimiento}
              onChange={(e) =>
                setForm({ ...form, fecha_vencimiento: e.target.value })
              }
              placeholder="YYYY-MM-DD"
            />
          </div>

          <div className="field">
            <label>Monto</label>
            <InputNumber
              value={form.monto}
              onValueChange={(e) => setForm({ ...form, monto: e.value })}
              mode="currency"
              currency="MXN"
            />
          </div>
        </div>

        <div className="flex justify-content-end mt-3">
          <Button
            label="Cancelar"
            className="p-button-text"
            onClick={() => setVisible(false)}
          />
          <Button label="Guardar" icon="pi pi-check" onClick={guardar} />
        </div>
      </Dialog>
    </Card>
  );
};

export default Cargos;
